import { render, staticRenderFns } from "./mod-app.vue?vue&type=template&id=42e5d1c9&scoped=true"
import script from "./mod-app.vue?vue&type=script&lang=js"
export * from "./mod-app.vue?vue&type=script&lang=js"
import style0 from "./mod-app.vue?vue&type=style&index=0&id=42e5d1c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e5d1c9",
  null
  
)

export default component.exports